
<template>
    <div style="height: 100%">
        <RelatorioFormularioRespostaList v-show="!rotaAninhada" :reloadData="reloadData" />
        <router-view />
    </div>
</template>

<script>
import RelatorioFormularioRespostaList from '@/components/promotor/relatorio-analitico/relatorio-formulario-resposta/RelatorioFormularioRespostaList.vue';

export default {
    name: 'RelatorioFormularioRespostaListRoute',

    beforeRouteUpdate(to, from, next) {
        this.rotaAninhada = to.name != 'relatorio-pro-formulario-resposta-list';
        if (from.name != 'relatorio-pro-formulario-resposta-list' && to.name == 'relatorio-pro-formulario-resposta-list') {
            this.reloadData = true;
            setTimeout(() => (this.reloadData = false), 300);
        }
        next();
    },
    components: {
        RelatorioFormularioRespostaList,
    },
    data() {
        return {
            rotaAninhada: false,
            reloadData: false,
        };
    },
    created() {
        this.rotaAninhada =
            this.$route.name.includes('relatorio-pro-formulario-resposta') &&
            this.$route.name != 'relatorio-pro-formulario-resposta-list';
    },
};
</script>
